import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubSupervisorAuth } from '../../context/SubSupervisorAuthContext';
import './SubSupervisorLoginPage.css';

const SubSupervisorLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login } = useSubSupervisorAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(username, password);
      navigate('/sub-supervisor/banks');
    } catch (err) {
      setError('Utilisateur ou mot de passe incorrect.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="ssl-page">
      <div className="ssl-card">
        <img className="ssl-logo" src="/logo-cgl.png" alt="CGL Multi-services" />
        <h2 className="ssl-title">Sous-superviseur</h2>
        <form onSubmit={handleSubmit}>
          <div className="ssl-group">
            <label className="ssl-label">Utilisateur</label>
            <input
              type="text"
              className="ssl-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="ssl-group">
            <label className="ssl-label">Mot de passe</label>
            <input
              type="password"
              className="ssl-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && <p className="ssl-error">{error}</p>}
          <button type="submit" className="ssl-btn" disabled={submitting}>
            {submitting ? 'Connexion...' : 'Connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubSupervisorLoginPage;
